import type * as core from '../../../../../../core'

export const PACKAGE = {
  contents: [
    'package:data.higherEd.externalInstitutions',
    'resource:data.dimensions.federalAgencies.entities.agency',
    'resource:data.dimensions.federalAgencies',
    'resource:data.dimensions.sponsors.entities.sponsor.attributes.federalAgency',
    'resource:data.dimensions.sponsors.entities.sponsor.attributes.institution',
    'resource:data.dimensions.sponsors.entities.sponsor.attributes.type',
    'resource:data.dimensions.sponsors.entities.sponsor',
    'resource:data.dimensions.sponsors',
    'resource:data.enums.sponsorType',
    'resource:data.enums.sponsorType.entries.externalOther',
    'resource:data.enums.sponsorType.entries.federal',
    'resource:data.enums.sponsorType.entries.industry',
    'resource:data.enums.sponsorType.entries.institutionalSupport',
    'resource:data.enums.sponsorType.entries.nonProfitFoundation',
    'resource:data.enums.sponsorType.entries.other',
  ],
  description: 'TODO',
  name: 'Research Data - Sponsors',
} as const satisfies core.quiver.Package
